import React, { Component } from 'react';
import { FormInput, SecureContainer, CheckBox } from '../../components';
import { validate, newUser } from '../../api';
import { notify } from '../../utils';
import { connect } from 'react-redux';
import { success } from '../../actions/auth-actions';
import { replace } from '../../actions/nav-actions';
import { countryList } from './constant';

class CreateOrganizationUser extends Component {
  state = {
    checked: true,
    organization: {},
    name: '',
    username: '',
    email: '',
    password: '',
    country: '',
  };
  onSubmit(event) {
    event.preventDefault();
    if (!this.state.checked) {
      return;
    }
    let { name, username, email, password, country } = this.state;
    newUser(this.state.organization.code, {
      name,
      username,
      email,
      password,
      country,
    })
      .then((user) => {
        this.props.success(user, '/');
      })
      .catch((err) => notify('Error', err.message, 'error'));
  }
  componentDidMount() {
    const { code } = this.props.match.params || {};
    validate(code)
      .then((organization) => this.setState({ organization }))
      .catch((e) => {
        this.props.replace('/');
        notify('Validation Error', e.message, 'error');
      });
  }
  handleCountryChange = (selectedCountry) => {
    this.setState({ country: selectedCountry });
  };
  render() {
    return (
      <SecureContainer title='New User'>
        {!!!this.state.organization && (
          <span className='text-center'>
            Fetching organization informations...
          </span>
        )}
        <form onSubmit={this.onSubmit.bind(this)}>
          <FormInput
            required
            onChange={(text) => this.setState({ name: text })}
            placeholder='Name'
          />
          <FormInput
            required
            onChange={(text) => this.setState({ username: text })}
            placeholder='Username'
          />
          <FormInput
            required
            onChange={(text) => this.setState({ email: text })}
            placeholder='Email'
          />
          <FormInput
            required
            onChange={(text) => this.setState({ password: text })}
            placeholder='Password'
            type='password'
          />
          <div
            className={`form-group clearfix ${this.props.containerClass}`}
            style={this.props.containerStyle}
          >
            <select
              required
              className='form-control'
              onChange={(event) => this.handleCountryChange(event.target.value)}
              value={this.state.country}
              placeholder='Country'
            >
              <option value='' disabled>
                Select your country
              </option>
              {countryList.map((country) => {
                return <option value={country}>{country}</option>;
              })}
              {/* Add more countries as needed */}
            </select>
          </div>
          <button
            disabled={!this.state.checked}
            type='submit'
            className='btn btn-info btn-block'
          >
            CREATE ACCOUNT
          </button>
          <div>
            <CheckBox
              style={{ marginTop: 16 }}
              checked={this.state.checked}
              onChange={(checked) => {
                this.setState({ checked: !this.state.checked });
              }}
              label='I agree to the Terms and Conditions of Masar'
            />
            <span style={{ marginTop: 8, textAlign: 'center' }}>
              By tapping "CREATE ACCOUNT", I agree to Masar`s
              <a href='http://secure.masar.tech/terms' target='_blank'>
                <span
                  style={{
                    textDecorationLine: 'underline',
                  }}
                >
                  {' '}
                  Terms of Service{' '}
                </span>
              </a>
              and
              <a target='_blank' href='http://secure.masar.tech/privacy'>
                <span
                  style={{
                    textDecorationLine: 'underline',
                  }}
                >
                  {' '}
                  Privacy Policy
                </span>
              </a>
              .
            </span>
          </div>
        </form>
      </SecureContainer>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  replace(routeName) {
    dispatch(replace(routeName));
  },
  success(user, routeName) {
    dispatch([success(user), replace(routeName)]);
  },
});

export default connect(null, mapDispatchToProps)(CreateOrganizationUser);



// WEBPACK FOOTER //
// ./src/routers/CreateOrganizationUser/index.js